import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('mediaManagement', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'DOWNLOAD',
    'FILEUPLOAD'
]);
export const initialMediaManagementState = {
    ...generateDefaultState('mediaManagement', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'DOWNLOAD',
        'FILEUPLOAD'
    ]),
};
